/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleIndexRouteImport } from './routes/$locale.index'
import { Route as LocaleTeacherInviteRouteImport } from './routes/$locale.teacher-invite'
import { Route as LocaleTasksRouteImport } from './routes/$locale.tasks'
import { Route as LocaleSignupRouteImport } from './routes/$locale.signup'
import { Route as LocaleSchoolSignupRouteImport } from './routes/$locale.school-signup'
import { Route as LocaleProgressRouteImport } from './routes/$locale.progress'
import { Route as LocaleMessagesRouteImport } from './routes/$locale.messages'
import { Route as LocaleKidsRouteImport } from './routes/$locale.kids'
import { Route as LocaleBillingRouteImport } from './routes/$locale.billing'
import { Route as LocaleBadgesRouteImport } from './routes/$locale.badges'
import { Route as LocaleAccountRouteImport } from './routes/$locale.account'
import { Route as LocaleTeacherTasksRouteImport } from './routes/$locale.teacher.tasks'
import { Route as LocaleTeacherMessagesRouteImport } from './routes/$locale.teacher.messages'
import { Route as LocaleTeacherClassesRouteImport } from './routes/$locale.teacher.classes'
import { Route as LocaleTeacherAssignmentsRouteImport } from './routes/$locale.teacher.assignments'
import { Route as LocaleSchoolTeachersRouteImport } from './routes/$locale.school.teachers'
import { Route as LocaleSchoolStudentsRouteImport } from './routes/$locale.school.students'
import { Route as LocaleSchoolClassesRouteImport } from './routes/$locale.school.classes'
import { Route as LocaleLessonLessonIdRouteImport } from './routes/$locale.lesson.$lessonId'
import { Route as LocaleCertificateUnitIdRouteImport } from './routes/$locale.certificate.$unitId'
import { Route as LocaleTeacherStudentStudentIdRouteImport } from './routes/$locale.teacher.student.$studentId'
import { Route as LocaleTeacherClassClassIdRouteImport } from './routes/$locale.teacher.class.$classId'
import { Route as LocaleBillingInvoicesInvoiceIdRouteImport } from './routes/$locale.billing.invoices.$invoiceId'

const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleIndexRoute = LocaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTeacherInviteRoute = LocaleTeacherInviteRouteImport.update({
  id: '/teacher-invite',
  path: '/teacher-invite',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTasksRoute = LocaleTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSignupRoute = LocaleSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSchoolSignupRoute = LocaleSchoolSignupRouteImport.update({
  id: '/school-signup',
  path: '/school-signup',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleProgressRoute = LocaleProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleMessagesRoute = LocaleMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleKidsRoute = LocaleKidsRouteImport.update({
  id: '/kids',
  path: '/kids',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleBillingRoute = LocaleBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleBadgesRoute = LocaleBadgesRouteImport.update({
  id: '/badges',
  path: '/badges',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleAccountRoute = LocaleAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTeacherTasksRoute = LocaleTeacherTasksRouteImport.update({
  id: '/teacher/tasks',
  path: '/teacher/tasks',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTeacherMessagesRoute = LocaleTeacherMessagesRouteImport.update({
  id: '/teacher/messages',
  path: '/teacher/messages',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTeacherClassesRoute = LocaleTeacherClassesRouteImport.update({
  id: '/teacher/classes',
  path: '/teacher/classes',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTeacherAssignmentsRoute =
  LocaleTeacherAssignmentsRouteImport.update({
    id: '/teacher/assignments',
    path: '/teacher/assignments',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleSchoolTeachersRoute = LocaleSchoolTeachersRouteImport.update({
  id: '/school/teachers',
  path: '/school/teachers',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSchoolStudentsRoute = LocaleSchoolStudentsRouteImport.update({
  id: '/school/students',
  path: '/school/students',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSchoolClassesRoute = LocaleSchoolClassesRouteImport.update({
  id: '/school/classes',
  path: '/school/classes',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleLessonLessonIdRoute = LocaleLessonLessonIdRouteImport.update({
  id: '/lesson/$lessonId',
  path: '/lesson/$lessonId',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleCertificateUnitIdRoute = LocaleCertificateUnitIdRouteImport.update({
  id: '/certificate/$unitId',
  path: '/certificate/$unitId',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTeacherStudentStudentIdRoute =
  LocaleTeacherStudentStudentIdRouteImport.update({
    id: '/teacher/student/$studentId',
    path: '/teacher/student/$studentId',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleTeacherClassClassIdRoute =
  LocaleTeacherClassClassIdRouteImport.update({
    id: '/teacher/class/$classId',
    path: '/teacher/class/$classId',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleBillingInvoicesInvoiceIdRoute =
  LocaleBillingInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => LocaleBillingRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/account': typeof LocaleAccountRoute
  '/$locale/badges': typeof LocaleBadgesRoute
  '/$locale/billing': typeof LocaleBillingRouteWithChildren
  '/$locale/kids': typeof LocaleKidsRoute
  '/$locale/messages': typeof LocaleMessagesRoute
  '/$locale/progress': typeof LocaleProgressRoute
  '/$locale/school-signup': typeof LocaleSchoolSignupRoute
  '/$locale/signup': typeof LocaleSignupRoute
  '/$locale/tasks': typeof LocaleTasksRoute
  '/$locale/teacher-invite': typeof LocaleTeacherInviteRoute
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/certificate/$unitId': typeof LocaleCertificateUnitIdRoute
  '/$locale/lesson/$lessonId': typeof LocaleLessonLessonIdRoute
  '/$locale/school/classes': typeof LocaleSchoolClassesRoute
  '/$locale/school/students': typeof LocaleSchoolStudentsRoute
  '/$locale/school/teachers': typeof LocaleSchoolTeachersRoute
  '/$locale/teacher/assignments': typeof LocaleTeacherAssignmentsRoute
  '/$locale/teacher/classes': typeof LocaleTeacherClassesRoute
  '/$locale/teacher/messages': typeof LocaleTeacherMessagesRoute
  '/$locale/teacher/tasks': typeof LocaleTeacherTasksRoute
  '/$locale/billing/invoices/$invoiceId': typeof LocaleBillingInvoicesInvoiceIdRoute
  '/$locale/teacher/class/$classId': typeof LocaleTeacherClassClassIdRoute
  '/$locale/teacher/student/$studentId': typeof LocaleTeacherStudentStudentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$locale/account': typeof LocaleAccountRoute
  '/$locale/badges': typeof LocaleBadgesRoute
  '/$locale/billing': typeof LocaleBillingRouteWithChildren
  '/$locale/kids': typeof LocaleKidsRoute
  '/$locale/messages': typeof LocaleMessagesRoute
  '/$locale/progress': typeof LocaleProgressRoute
  '/$locale/school-signup': typeof LocaleSchoolSignupRoute
  '/$locale/signup': typeof LocaleSignupRoute
  '/$locale/tasks': typeof LocaleTasksRoute
  '/$locale/teacher-invite': typeof LocaleTeacherInviteRoute
  '/$locale': typeof LocaleIndexRoute
  '/$locale/certificate/$unitId': typeof LocaleCertificateUnitIdRoute
  '/$locale/lesson/$lessonId': typeof LocaleLessonLessonIdRoute
  '/$locale/school/classes': typeof LocaleSchoolClassesRoute
  '/$locale/school/students': typeof LocaleSchoolStudentsRoute
  '/$locale/school/teachers': typeof LocaleSchoolTeachersRoute
  '/$locale/teacher/assignments': typeof LocaleTeacherAssignmentsRoute
  '/$locale/teacher/classes': typeof LocaleTeacherClassesRoute
  '/$locale/teacher/messages': typeof LocaleTeacherMessagesRoute
  '/$locale/teacher/tasks': typeof LocaleTeacherTasksRoute
  '/$locale/billing/invoices/$invoiceId': typeof LocaleBillingInvoicesInvoiceIdRoute
  '/$locale/teacher/class/$classId': typeof LocaleTeacherClassClassIdRoute
  '/$locale/teacher/student/$studentId': typeof LocaleTeacherStudentStudentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/account': typeof LocaleAccountRoute
  '/$locale/badges': typeof LocaleBadgesRoute
  '/$locale/billing': typeof LocaleBillingRouteWithChildren
  '/$locale/kids': typeof LocaleKidsRoute
  '/$locale/messages': typeof LocaleMessagesRoute
  '/$locale/progress': typeof LocaleProgressRoute
  '/$locale/school-signup': typeof LocaleSchoolSignupRoute
  '/$locale/signup': typeof LocaleSignupRoute
  '/$locale/tasks': typeof LocaleTasksRoute
  '/$locale/teacher-invite': typeof LocaleTeacherInviteRoute
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/certificate/$unitId': typeof LocaleCertificateUnitIdRoute
  '/$locale/lesson/$lessonId': typeof LocaleLessonLessonIdRoute
  '/$locale/school/classes': typeof LocaleSchoolClassesRoute
  '/$locale/school/students': typeof LocaleSchoolStudentsRoute
  '/$locale/school/teachers': typeof LocaleSchoolTeachersRoute
  '/$locale/teacher/assignments': typeof LocaleTeacherAssignmentsRoute
  '/$locale/teacher/classes': typeof LocaleTeacherClassesRoute
  '/$locale/teacher/messages': typeof LocaleTeacherMessagesRoute
  '/$locale/teacher/tasks': typeof LocaleTeacherTasksRoute
  '/$locale/billing/invoices/$invoiceId': typeof LocaleBillingInvoicesInvoiceIdRoute
  '/$locale/teacher/class/$classId': typeof LocaleTeacherClassClassIdRoute
  '/$locale/teacher/student/$studentId': typeof LocaleTeacherStudentStudentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale'
    | '/$locale/account'
    | '/$locale/badges'
    | '/$locale/billing'
    | '/$locale/kids'
    | '/$locale/messages'
    | '/$locale/progress'
    | '/$locale/school-signup'
    | '/$locale/signup'
    | '/$locale/tasks'
    | '/$locale/teacher-invite'
    | '/$locale/'
    | '/$locale/certificate/$unitId'
    | '/$locale/lesson/$lessonId'
    | '/$locale/school/classes'
    | '/$locale/school/students'
    | '/$locale/school/teachers'
    | '/$locale/teacher/assignments'
    | '/$locale/teacher/classes'
    | '/$locale/teacher/messages'
    | '/$locale/teacher/tasks'
    | '/$locale/billing/invoices/$invoiceId'
    | '/$locale/teacher/class/$classId'
    | '/$locale/teacher/student/$studentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$locale/account'
    | '/$locale/badges'
    | '/$locale/billing'
    | '/$locale/kids'
    | '/$locale/messages'
    | '/$locale/progress'
    | '/$locale/school-signup'
    | '/$locale/signup'
    | '/$locale/tasks'
    | '/$locale/teacher-invite'
    | '/$locale'
    | '/$locale/certificate/$unitId'
    | '/$locale/lesson/$lessonId'
    | '/$locale/school/classes'
    | '/$locale/school/students'
    | '/$locale/school/teachers'
    | '/$locale/teacher/assignments'
    | '/$locale/teacher/classes'
    | '/$locale/teacher/messages'
    | '/$locale/teacher/tasks'
    | '/$locale/billing/invoices/$invoiceId'
    | '/$locale/teacher/class/$classId'
    | '/$locale/teacher/student/$studentId'
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/$locale/account'
    | '/$locale/badges'
    | '/$locale/billing'
    | '/$locale/kids'
    | '/$locale/messages'
    | '/$locale/progress'
    | '/$locale/school-signup'
    | '/$locale/signup'
    | '/$locale/tasks'
    | '/$locale/teacher-invite'
    | '/$locale/'
    | '/$locale/certificate/$unitId'
    | '/$locale/lesson/$lessonId'
    | '/$locale/school/classes'
    | '/$locale/school/students'
    | '/$locale/school/teachers'
    | '/$locale/teacher/assignments'
    | '/$locale/teacher/classes'
    | '/$locale/teacher/messages'
    | '/$locale/teacher/tasks'
    | '/$locale/billing/invoices/$invoiceId'
    | '/$locale/teacher/class/$classId'
    | '/$locale/teacher/student/$studentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleRoute: typeof LocaleRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/': {
      id: '/$locale/'
      path: '/'
      fullPath: '/$locale/'
      preLoaderRoute: typeof LocaleIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher-invite': {
      id: '/$locale/teacher-invite'
      path: '/teacher-invite'
      fullPath: '/$locale/teacher-invite'
      preLoaderRoute: typeof LocaleTeacherInviteRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/tasks': {
      id: '/$locale/tasks'
      path: '/tasks'
      fullPath: '/$locale/tasks'
      preLoaderRoute: typeof LocaleTasksRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/signup': {
      id: '/$locale/signup'
      path: '/signup'
      fullPath: '/$locale/signup'
      preLoaderRoute: typeof LocaleSignupRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/school-signup': {
      id: '/$locale/school-signup'
      path: '/school-signup'
      fullPath: '/$locale/school-signup'
      preLoaderRoute: typeof LocaleSchoolSignupRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/progress': {
      id: '/$locale/progress'
      path: '/progress'
      fullPath: '/$locale/progress'
      preLoaderRoute: typeof LocaleProgressRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/messages': {
      id: '/$locale/messages'
      path: '/messages'
      fullPath: '/$locale/messages'
      preLoaderRoute: typeof LocaleMessagesRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/kids': {
      id: '/$locale/kids'
      path: '/kids'
      fullPath: '/$locale/kids'
      preLoaderRoute: typeof LocaleKidsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/billing': {
      id: '/$locale/billing'
      path: '/billing'
      fullPath: '/$locale/billing'
      preLoaderRoute: typeof LocaleBillingRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/badges': {
      id: '/$locale/badges'
      path: '/badges'
      fullPath: '/$locale/badges'
      preLoaderRoute: typeof LocaleBadgesRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/account': {
      id: '/$locale/account'
      path: '/account'
      fullPath: '/$locale/account'
      preLoaderRoute: typeof LocaleAccountRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher/tasks': {
      id: '/$locale/teacher/tasks'
      path: '/teacher/tasks'
      fullPath: '/$locale/teacher/tasks'
      preLoaderRoute: typeof LocaleTeacherTasksRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher/messages': {
      id: '/$locale/teacher/messages'
      path: '/teacher/messages'
      fullPath: '/$locale/teacher/messages'
      preLoaderRoute: typeof LocaleTeacherMessagesRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher/classes': {
      id: '/$locale/teacher/classes'
      path: '/teacher/classes'
      fullPath: '/$locale/teacher/classes'
      preLoaderRoute: typeof LocaleTeacherClassesRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher/assignments': {
      id: '/$locale/teacher/assignments'
      path: '/teacher/assignments'
      fullPath: '/$locale/teacher/assignments'
      preLoaderRoute: typeof LocaleTeacherAssignmentsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/school/teachers': {
      id: '/$locale/school/teachers'
      path: '/school/teachers'
      fullPath: '/$locale/school/teachers'
      preLoaderRoute: typeof LocaleSchoolTeachersRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/school/students': {
      id: '/$locale/school/students'
      path: '/school/students'
      fullPath: '/$locale/school/students'
      preLoaderRoute: typeof LocaleSchoolStudentsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/school/classes': {
      id: '/$locale/school/classes'
      path: '/school/classes'
      fullPath: '/$locale/school/classes'
      preLoaderRoute: typeof LocaleSchoolClassesRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/lesson/$lessonId': {
      id: '/$locale/lesson/$lessonId'
      path: '/lesson/$lessonId'
      fullPath: '/$locale/lesson/$lessonId'
      preLoaderRoute: typeof LocaleLessonLessonIdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/certificate/$unitId': {
      id: '/$locale/certificate/$unitId'
      path: '/certificate/$unitId'
      fullPath: '/$locale/certificate/$unitId'
      preLoaderRoute: typeof LocaleCertificateUnitIdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher/student/$studentId': {
      id: '/$locale/teacher/student/$studentId'
      path: '/teacher/student/$studentId'
      fullPath: '/$locale/teacher/student/$studentId'
      preLoaderRoute: typeof LocaleTeacherStudentStudentIdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/teacher/class/$classId': {
      id: '/$locale/teacher/class/$classId'
      path: '/teacher/class/$classId'
      fullPath: '/$locale/teacher/class/$classId'
      preLoaderRoute: typeof LocaleTeacherClassClassIdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/billing/invoices/$invoiceId': {
      id: '/$locale/billing/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/$locale/billing/invoices/$invoiceId'
      preLoaderRoute: typeof LocaleBillingInvoicesInvoiceIdRouteImport
      parentRoute: typeof LocaleBillingRoute
    }
  }
}

interface LocaleBillingRouteChildren {
  LocaleBillingInvoicesInvoiceIdRoute: typeof LocaleBillingInvoicesInvoiceIdRoute
}

const LocaleBillingRouteChildren: LocaleBillingRouteChildren = {
  LocaleBillingInvoicesInvoiceIdRoute: LocaleBillingInvoicesInvoiceIdRoute,
}

const LocaleBillingRouteWithChildren = LocaleBillingRoute._addFileChildren(
  LocaleBillingRouteChildren,
)

interface LocaleRouteChildren {
  LocaleAccountRoute: typeof LocaleAccountRoute
  LocaleBadgesRoute: typeof LocaleBadgesRoute
  LocaleBillingRoute: typeof LocaleBillingRouteWithChildren
  LocaleKidsRoute: typeof LocaleKidsRoute
  LocaleMessagesRoute: typeof LocaleMessagesRoute
  LocaleProgressRoute: typeof LocaleProgressRoute
  LocaleSchoolSignupRoute: typeof LocaleSchoolSignupRoute
  LocaleSignupRoute: typeof LocaleSignupRoute
  LocaleTasksRoute: typeof LocaleTasksRoute
  LocaleTeacherInviteRoute: typeof LocaleTeacherInviteRoute
  LocaleIndexRoute: typeof LocaleIndexRoute
  LocaleCertificateUnitIdRoute: typeof LocaleCertificateUnitIdRoute
  LocaleLessonLessonIdRoute: typeof LocaleLessonLessonIdRoute
  LocaleSchoolClassesRoute: typeof LocaleSchoolClassesRoute
  LocaleSchoolStudentsRoute: typeof LocaleSchoolStudentsRoute
  LocaleSchoolTeachersRoute: typeof LocaleSchoolTeachersRoute
  LocaleTeacherAssignmentsRoute: typeof LocaleTeacherAssignmentsRoute
  LocaleTeacherClassesRoute: typeof LocaleTeacherClassesRoute
  LocaleTeacherMessagesRoute: typeof LocaleTeacherMessagesRoute
  LocaleTeacherTasksRoute: typeof LocaleTeacherTasksRoute
  LocaleTeacherClassClassIdRoute: typeof LocaleTeacherClassClassIdRoute
  LocaleTeacherStudentStudentIdRoute: typeof LocaleTeacherStudentStudentIdRoute
}

const LocaleRouteChildren: LocaleRouteChildren = {
  LocaleAccountRoute: LocaleAccountRoute,
  LocaleBadgesRoute: LocaleBadgesRoute,
  LocaleBillingRoute: LocaleBillingRouteWithChildren,
  LocaleKidsRoute: LocaleKidsRoute,
  LocaleMessagesRoute: LocaleMessagesRoute,
  LocaleProgressRoute: LocaleProgressRoute,
  LocaleSchoolSignupRoute: LocaleSchoolSignupRoute,
  LocaleSignupRoute: LocaleSignupRoute,
  LocaleTasksRoute: LocaleTasksRoute,
  LocaleTeacherInviteRoute: LocaleTeacherInviteRoute,
  LocaleIndexRoute: LocaleIndexRoute,
  LocaleCertificateUnitIdRoute: LocaleCertificateUnitIdRoute,
  LocaleLessonLessonIdRoute: LocaleLessonLessonIdRoute,
  LocaleSchoolClassesRoute: LocaleSchoolClassesRoute,
  LocaleSchoolStudentsRoute: LocaleSchoolStudentsRoute,
  LocaleSchoolTeachersRoute: LocaleSchoolTeachersRoute,
  LocaleTeacherAssignmentsRoute: LocaleTeacherAssignmentsRoute,
  LocaleTeacherClassesRoute: LocaleTeacherClassesRoute,
  LocaleTeacherMessagesRoute: LocaleTeacherMessagesRoute,
  LocaleTeacherTasksRoute: LocaleTeacherTasksRoute,
  LocaleTeacherClassClassIdRoute: LocaleTeacherClassClassIdRoute,
  LocaleTeacherStudentStudentIdRoute: LocaleTeacherStudentStudentIdRoute,
}

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRoute: LocaleRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
